import React from 'react';
import styled from 'styled-components';
import MotifTextLink from '@ey/motif-react-wrapper/TextLink';
import EllipseControl from '../EllipsesControl/EllipsesControl';

export default function TextLink(props) {
	const {
			id,
			className,
			title,
			variant,
			disabled,
			href,
			target,
			isEllipsed,
			tooltipClass,
			noOfLines,
			label,
			children
		} = props,
		lines = noOfLines ? noOfLines : 1;

	const linkContent = (
		<>
			{children ? (
				children
			) : isEllipsed ? (
				<EllipseControl tooltipClass={tooltipClass} content={label} tooltip={label} noOfLines={lines} />
			) : (
				label
			)}
		</>
	);

	return (
		<StyledMotifTextLink
			id={id}
			className={className}
			title={title}
			variant={variant}
			disabled={disabled}
			href={href}
			target={target}
			isEllipsed={isEllipsed}
			noOfLines={noOfLines}
		>
			{linkContent}
		</StyledMotifTextLink>
	);
}

const StyledMotifTextLink = styled(MotifTextLink)``;
